import { createComponent } from '@carvana/vdp-components';
import styled from 'styled-components';

export const ScrollContainer = styled('aside').attrs({
  className:
    'border border-l-0 border-solid border-grey-2 hidden h-[calc(100vh-32px)] overflow-y-auto rounded-md sticky top-[32px] w-full l:block'
})`
  // TODO: Switch this to a CSS module when we move to NextJS
  .ScrollbarsCustom-TrackY:has(.dragging) {
    opacity: 100;
  }
`;

export const BorderWrapper = createComponent('div', {
  className: 'border border-grey-2 border-solid border-t-0 rounded-md'
});
